import { render, staticRenderFns } from "./home-faq.vue?vue&type=template&id=6db9bc68&scoped=true&"
import script from "./home-faq.vue?vue&type=script&lang=js&"
export * from "./home-faq.vue?vue&type=script&lang=js&"
import style0 from "./home-faq.vue?vue&type=style&index=0&id=6db9bc68&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db9bc68",
  null
  
)

export default component.exports